export default __webpack_public_path__ + "static/media/date_blank.4e9fef22.svg";